import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';

const SmartAI = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '智能算法',
      content: '运用先进的人工智能算法，提供智能化解决方案。我们的智慧AI系统采用先进的人工智能技术，包括机器学习、深度学习和自然语言处理等核心技术，为用户提供全方位的智能化解决方案。',
      img: <img src="/src/img/zhfw.png" alt="" />
    },
    {
      title: '机器学习',
      content: '基于机器学习技术，实现智能分析和预测。系统具备强大的数据分析能力，可以实现智能预测、模式识别和自动决策等功能。',
      img: <img src="/src/img/zhfw.png" alt="" />
    },
    {
      title: '深度学习',
      content: '应用深度学习技术，提供更智能的服务体验。通过深度学习技术，系统能够自动学习和优化，不断提升服务质量和用户体验。',
      img: <img src="/src/img/zhfw.png" alt="" />
    },
    {
      title: '自然语言处理',
      content: '先进的自然语言处理技术，实现智能交互和理解。系统能够准确理解和处理人类语言，提供智能对话和语言分析服务。',
      img: <img src="/src/img/zhfw.png" alt="" />
    },
    {
      title: '计算机视觉',
      content: '强大的计算机视觉技术，实现图像识别和处理。系统具备图像识别、目标检测、场景理解等功能，为视觉相关应用提供支持。',
      img: <img src="/src/img/zhfw.png" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧AI系统</h1>
      </div>
      <div className="page-container">
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="ai-content">
              <div className="ai-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmartAI;